"use client";

import { motion } from "framer-motion";

export function About() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.65, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="mx-auto w-full max-w-sm flex flex-col items-center text-center"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="mb-6"
      >
        <h1 className="font-serif text-[3.2rem] font-semibold leading-tight tracking-[-0.04em] text-foreground sm:text-[3.8rem]">
          notzz
        </h1>
      </motion.div>


      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.25 }}
        className="text-[0.9rem] leading-[1.7] text-muted/90"
      >
        When u can't be controlled, you will be hated, and that's power
      </motion.p>

      
    </motion.div>
  );
}
